import { render, staticRenderFns } from "./CategoriesIcon.vue?vue&type=template&id=642d872f&scoped=true"
import script from "./CategoriesIcon.vue?vue&type=script&lang=js"
export * from "./CategoriesIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642d872f",
  null
  
)

export default component.exports